import * as Sentry from '@sentry/nextjs'
import PageServerError from 'ui/page-server-error/PageServerError'
import Head from 'next/head'
import { NextPageContext } from 'next'

function Error() {
  return (
    <>
      <Head>
        <title>ablefy | 500</title>
      </Head>
      <PageServerError hideGoBack />
    </>
  )
}

Error.getInitialProps = async (ctx: NextPageContext) => {
  await Sentry.captureUnderscoreErrorException(ctx)

  return { isErrorPage: true }
}

export default Error
